import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import PsContext from "../../context";

import { useNavigate } from "react-router-dom";
import { ServiceUrl } from "../../utils/serviceUrl";
import CollegeLogo from "../collegeLogo";
import { MOB_ICONS, upperCase } from "../../utils";
import { TextField } from "@mui/material";

const V2SingleUsername = (props) => {
  const context = useContext(PsContext);
  const navigation = useNavigate();
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    if (form.mobile.value.length != 10) {
      Toast.show({
        content: "Enter 10 digit mobile number",
        position: "top",
      });
      return;
    }
    context.setLoader(true);
    axios
      .post(ServiceUrl.LOGIN_V2.CHECK_MOBILE_NUMBER, new FormData(form))
      .then((res) => {
        if (res.data.status == "1") {
          if (props.onSuccess) props.onSuccess(res.data.data);
        } else {
          Toast.show({
            content: res["data"].message || "Error",
            position: "top",
          });
        }
        context.setLoader(false);
      });
  };

  return (
    <>
      <div data-aos="zoom-in">
        <div className="login-img mt-5 d-flex justify-content-center align-content-center">
          <img
            className="theme-login-img"
            src={MOB_ICONS.MAN_256}
            style={{ width: "100%", maxWidth: "120px" }}
          />
        </div>
        <div className="login my-4">
          <h2 className="fw-bold text-center">Welcome</h2>
          <p className="text-center">Sign in to access your account</p>
        </div>

        <div className="py-4">
          <Form
            action=""
            method="post"
            noValidate
            validated={validated}
            onSubmit={handleFormSubmit}
          >
            <Row>
              <Col md={12}>
                {/* <Form.Control
                  type="number"
                  className="fw-bold"
                  name="mobile"
                  placeholder="Enter Mobile Number"
                  autoComplete={"off"}
                  autoFocus={true}
                  required
                /> */}
                <TextField
                  id="outlined-basic"
                  type="number"
                  className="fw-bold bg-white"
                  name="mobile"
                  label="Enter Mobile Number"
                  autoComplete={"off"}
                  autoFocus={true}
                  required
                  fullWidth
                  variant="outlined"
                />
                <Form.Control.Feedback type="invalid">
                  Mobile Number is required
                </Form.Control.Feedback>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={12}>
                <Button
                  type="submit"
                  variant="danger"
                  size="lg"
                  className="w-100 bg-theme"
                >
                  Go Next
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};
export default V2SingleUsername;
